import {ActionTypes} from "./types";

const INITIAL_STATE = {
  memberships: undefined
};

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ActionTypes.SET_MEMBERSHIPS:
      return {
        ...state,
        memberships: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;